// Firebase Cloud Messaging Configuration File.
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// var firebaseConfig = {
//   apiKey: "AIzaSyAv9Pn8M3VbvBsMKSN0E0oENBHAkG-z6yU",
// authDomain: "omantelsip-bceed.firebaseapp.com",
// projectId: "omantelsip-bceed",
// storageBucket: "omantelsip-bceed.appspot.com",
// messagingSenderId: "906196310572",
// appId: "1:906196310572:web:8457fd2a4482417c858f89",
// measurementId: "G-SZSYBHWZC4"
// };

var firebaseConfig = {
  apiKey: "AIzaSyD5dCkpAvTiccPMtEnhjmZpoxi7XTJFRwQ",
  authDomain: "quiz-survey-481eb.firebaseapp.com",
  projectId: "quiz-survey-481eb",
  storageBucket: "quiz-survey-481eb.firebasestorage.app",
  messagingSenderId: "410485720794",
  appId: "1:410485720794:web:1a2c156aa2b1ce810d47e3",
  measurementId: "G-LZH9DPJLTC",
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("Notification permission not granted");
      return null;
    }
    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey:
        "BOj4-vyVNnq8MC-2ldR3N3U8GAMoPU0Gd8-UccDmEUSvW_R-ngjoTtwcDAf7mh7w-wFTxMN_dE_RPSHYmDtqO8Y",
      serviceWorkerRegistration: registration,
    });

    console.log("FCM TOKEN ->>>>>>>>>>>>>", token);
    return token;
  } catch (err) {
    console.error("FCM error:", err);
    return null;
  }
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
